<template>
  <couponDetails></couponDetails>
</template>

<script>
import CouponDetails from "@/components/MasterSetup/Coupon/CouponDetails"
export default {
    components:{
        CouponDetails
    }
}
</script>

<style>

</style>